<template>
  <div id="app">
    <Header v-if="device != 'mobile'"></Header>
    <router-view />
    <Footer v-if="device != 'mobile'"></Footer>
  </div>
</template>

<script>
import Header from './components/Header';
import Footer from './components/Footer';
import { mapState } from 'vuex';
import { deviceEnquire, DEVICE_TYPE } from '@/helpers/device';
export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  computed: {
    ...mapState(['systemInfo', 'device'])
  },
  created() {
    this.initSite();
  },
  mounted() {
    const { $store } = this;
    deviceEnquire(deviceType => {
      // console.log("当前分辨率", deviceType);
      switch (deviceType) {
        case DEVICE_TYPE.DESKTOP:
          $store.commit('TOGGLE_DEVICE', 'desktop');
          break;
        case DEVICE_TYPE.TABLET:
          $store.commit('TOGGLE_DEVICE', 'tablet');
          break;
        case DEVICE_TYPE.MOBILE:
        default:
          $store.commit('TOGGLE_DEVICE', 'mobile');
          break;
      }
    });
  },
  methods: {
    async initSite() {
      this.$store.dispatch('systemInfo');
      this.$store.dispatch('indexPageInfo');
    }
  }
};
</script>
<style lang="less" scoped>
#app {
  // overflow: scroll;
  // width: 130%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue